import { Decoder, array, constant, either, iso8601, number, object, string } from "decoders";
import { WellLevelsRecord, wellLevelsRecordDecoder } from "./wellLevelsData";
import { WellLevelRecord, wellLevelRecordDecoder } from "./scada/wellLevel";

export const printWidth = "700px";

export type PrintData = PrintDashboardData | PrintWellLevelsData;

export type ProjectId = "surfaceWater" | "groundWater" | "drinkingWater";

export interface PrintDashboardData {
  type: "dashboardData";
  project: ProjectId;
  analyte: string;
  sites: string[];
  startDate: Date;
  endDate: Date;
  samples: PrintDataEntry[];
}

export interface PrintDataEntry {
  site: string;
  sampleDate: Date;
  measurementResult: number;
}

export const printDashboardDataDecoder: Decoder<PrintDashboardData> = object({
  type: constant("dashboardData"),
  project: either(constant("surfaceWater"), constant("groundWater"), constant("drinkingWater")),
  analyte: string,
  sites: array(string),
  startDate: iso8601,
  endDate: iso8601,
  samples: array(
    object({
      site: string,
      sampleDate: iso8601,
      measurementResult: number,
    }),
  ),
});

export interface PrintWellLevelsData {
  type: "wellLevelsData";
  startDate: Date;
  endDate: Date;
  sites: string[];
  wellLevels: WellLevelsRecord[];
  scadaWellLevels: WellLevelRecord[];
}

export const printWellLevelsDataDecoder: Decoder<PrintWellLevelsData> = object({
  type: constant("wellLevelsData"),
  startDate: iso8601,
  endDate: iso8601,
  sites: array(string),
  wellLevels: array(wellLevelsRecordDecoder),
  scadaWellLevels: array(wellLevelRecordDecoder),
});

export const printDataDecoder: Decoder<PrintData> = either(printDashboardDataDecoder, printWellLevelsDataDecoder);
